import { render, staticRenderFns } from "./orderdizhiForm.vue?vue&type=template&id=0954d8de&scoped=true&"
import script from "./orderdizhiForm.vue?vue&type=script&lang=js&"
export * from "./orderdizhiForm.vue?vue&type=script&lang=js&"
import style0 from "./orderdizhiForm.vue?vue&type=style&index=0&id=0954d8de&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954d8de",
  null
  
)

export default component.exports